import React, { useEffect, useState } from "react";
import {
  Box, Card, Divider, Typography, Grid,
  CardMedia, CardContent, IconButton
} from "@mui/material";
import ModalPopupStudio from "./ModalPopupStudio";

interface Selection {
  cardTitle: string;
  sides: {
    left: boolean;
    right: boolean;
  };
 
}
export const cameraCards = [
  {
    image: '/assets/TruckImage.svg',
    title: "Truck Left",
    subTitle: "Truck Right",
    button1Icon: <img src={'/assets/TruckLeft.svg'} alt="Zoom In" width={20} height={20}/>,
    button2Icon: <img src={'/assets/TruckRight.svg'} alt="Zoom In" width={20} height={20}/>,
    videoLeft: "/assets/truckleft.mov",
    videoRight: "/assets/tructright.mp4",
  },
  {
    image: '/assets/PanImage.svg',
    title: "Pan Left",
    subTitle: "Pan Right",
    button1Icon: <img src={'/assets/PanLeft.svg'} alt="Pan Left" width={15} height={15} />,
    button2Icon: <img src={'/assets/PanRight.svg'} alt="Pan Right" width={15} height={15}/>,
    videoLeft: "/assets/panleft.mp4",
    videoRight: "/assets/panright.mp4",
  },
  {
    image: '/assets/PushImage.svg',
    title: "Push In",
    subTitle: "Pull Out",
    button1Icon: <img src={'/assets/PushIn.svg'} alt="Push In" width={15} height={15}/>,
    button2Icon: <img src={'/assets/'} alt="Push Out" width={15} height={15}/>,
    videoLeft: "/assets/pushin.mp4",
    videoRight: "/assets/pushout.mp4",
  },
  {
    image: '/assets/ZoomImage.svg',
    title: "Zoom In",
    subTitle: "Zoom Out",
    button1Icon: <img src={'/assets/ZoomIn.svg'} alt="Zoom In" width={15} height={15}/>,
    button2Icon: <img src={'/assets/ZoomOut.svg'} alt="Zoom Out" width={15} height={15}/>,
    videoLeft: "/assets/zoomin.mp4",
    videoRight: "/assets/zoomout.mp4",
  },
  {
    image: '/assets/PedestalImage.svg',
    title: "Pedestal up",
    subTitle: "Pedestal down",
    button1Icon: <img src={'/assets/PedestalUp.svg'} alt="Zoom In" width={15} height={20}/>,
    button2Icon: <img src={'/assets/PedestalDown.svg'} alt="Zoom In" width={15} height={15}/>,
    videoLeft: "/assets/pedestalup.mp4",
    videoRight: "/assets/pedestaldown.mp4",
  },
  {
    image: '/assets/TiltImage.svg',
    title: "Tilt Up",
    subTitle: "Tilt Down",
    button1Icon: <img src={'/assets/Tilt.svg'} alt="Tilt Up" width={15} height={15}/>,
    button2Icon: <img src={'/assets/TiltDown.svg'} alt="Tilt Down" width={15} height={15}/>,
    videoLeft: "/assets/tiltup.mp4",
    videoRight: "/assets/tiltdown.mp4",
  },
  {
    image: '/assets/ShakeImage.svg',
    title: "Shake",
    button1Icon: <img src={'/assets/Shake.svg'} alt="Shake"  width={20} height={20}/>,
    videoLeft: "/assets/shake.mp4",
  },
  {
    image: '/assets/TrackingImage.svg',
    title: "Tracking Shoot",
    button1Icon: <img src={'/assets/Tracking.svg'} alt="Tracking" width={15} height={15}/>,
    videoLeft: "/assets/tracking.mp4",
  },
];

export default function CameraControls({ image, videoShot, setVideoShot, setPrompt, prompt,uploadfile }: {
     image: string | null; 
     setVideoShot: (value: boolean) => void;
      videoShot: boolean;
      prompt: string;
      setPrompt: (value: string) => void;
      uploadfile: any;
     }) {

  const [selectedCard, setSelectedCard] = useState<any>(null);
  const [selected, setSelected] = useState<Selection[]>([]);
  const [hoveredCardIndex, setHoveredCardIndex] = useState<number | null>(null); 
  const [localPrompt, setLocalPrompt] = useState<string>("");
useEffect (()=>{
if(!prompt){
  setSelected([])
}
},[prompt])

const handleControlClick = (card: any, side: 'left' | 'right') => {
  setSelected((prev: Selection[]) => {
    const total = prev.reduce(
      (sum, sel) => sum + (sel.sides.left ? 1 : 0) + (sel.sides.right ? 1 : 0),
      0
    );

    const index = prev.findIndex(sel => sel.cardTitle === card.title);
    const current = index >= 0
      ? prev[index]
      : { cardTitle: card.title, sides: { left: false, right: false } };

    // If trying to turn ON and already at 3, block it
    if (!current.sides[side] && total >= 3) return prev;

    const updatedSides = { ...current.sides, [side]: !current.sides[side] };
    const updated = { ...current, sides: updatedSides };

    const newSelections = [
      ...prev.filter((_, i) => i !== index),
      ...(updated.sides.left || updated.sides.right ? [updated] : [])
    ];
    // Update prompt
    const cameraControls: string[] = [];
    newSelections.forEach(sel => {
      const c = cameraCards.find(cc => cc.title === sel.cardTitle);
      if (sel.sides.left && c?.title) cameraControls.push(c.title);
      if (sel.sides.right && c?.subTitle) cameraControls.push(c.subTitle);
    });

    // Extract user prompt (remove previous camera controls if present)
    const userPrompt = prompt.replace(/^\[.*\]\s*/g, "");

    const controlText = cameraControls.length > 0 ? `[${cameraControls.join(", ")}] ` : "";
    setLocalPrompt(`${controlText}${userPrompt}`.trim());

    setSelectedCard(card);
    return newSelections;
  });
};
  
  useEffect(()=>{
    setPrompt(localPrompt);
  },[localPrompt, setPrompt])
  

  return (
    <Box className="cameraControlContainer">
      <Card className="cameraControlCard">
        <Box>
          <Typography className="cameraControlTitle">Camera Controls</Typography>
           <Box>
          <Typography className="finalText">Tips: maximum of 3 camera shot combinations</Typography>
        </Box>
          <Divider className="studioDivider" />
        </Box>
        <Grid container spacing={2} padding={2} className="cameraControlGrid">
          {cameraCards.map((card, index) => (
            <Grid item xs={6} key={index}>
              <Card
                className="cameraControlItem"
                onMouseLeave={() => setHoveredCardIndex(null)}
              
              >
                <CardContent className="cameraControlImageContainer"   onClick={() => {
                  setSelectedCard(card);
                  setVideoShot(true);
                }}>
                  
                <CardMedia
                  component="img"
                  image={card.image}
                  className="cameraControlImage"
                  alt={card.title}
                  onMouseEnter={() => setHoveredCardIndex(index)} 
                  
                />
                <Box className="cameraControlImageOverlay">
                <img src={'/assets/Cameracontrol.svg'} alt={card.title} className="cameraImage" />
                </Box>
                 {hoveredCardIndex === index && card.image && (
                  <Box className="visibilityIconContainer">
                    <img src={'/assets/VisibleIcon.svg'} alt="VisibleIcon" className="visibilityIcon" />
                  </Box>
                )}
                </CardContent>
                <CardContent className="cameraControlContent">
                  <Box className={card.subTitle ? "cameraControlBox" : "cameraControlBoxNosubTitle"}
                    onClick={() => handleControlClick(card, "left")}
                  >
                    <IconButton className="cameraControlButton">{card.button1Icon}</IconButton>
                    <Typography variant="body2" className="buttontitle">{card.title}</Typography>
                  </Box>
                  {card.subTitle && (
                    <Box className="cameraControlBoxRight"
                    onClick={() => handleControlClick(card, "right")}
                    >
                      <IconButton className="cameraControlButton">{card.button2Icon}</IconButton>
                      <Typography variant="body2" className="buttontitle">{card.subTitle}</Typography>
                    </Box>
                  )}
                </CardContent>
               
              </Card>
            </Grid>
          ))}
        </Grid>
       
      </Card>

      {videoShot && selectedCard &&
        <ModalPopupStudio
          videoShot={videoShot}
          setVideoShot={setVideoShot}
          selected={selected}
          setSelected={setSelected}
          selectedCard={selectedCard}
          setPrompt={setPrompt}
          prompt={prompt}
          uploadfile={uploadfile}
          type="camera"
        />
      }
    </Box>
  );
}